import { render, staticRenderFns } from "./test-0236.vue?vue&type=template&id=b0b79202&scoped=true"
import script from "./test-0236.vue?vue&type=script&lang=js"
export * from "./test-0236.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b79202",
  null
  
)

export default component.exports